import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "mobile-mj"
};
const _hoisted_2 = {
  class: "text-line"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
  class: "icon"
};
const _hoisted_5 = {
  class: "text"
};
const _hoisted_6 = {
  class: "text-line"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  class: "icon"
};
const _hoisted_9 = {
  class: "text"
};
const _hoisted_10 = {
  class: "text-line"
};
const _hoisted_11 = {
  class: "text-line"
};
const _hoisted_12 = {
  class: "text-line"
};
const _hoisted_13 = {
  class: "text-line"
};
const _hoisted_14 = {
  class: "text-line"
};
const _hoisted_15 = {
  class: "text-line"
};
const _hoisted_16 = {
  class: "text-line"
};
const _hoisted_17 = {
  class: "text-line"
};
const _hoisted_18 = {
  class: "text-line"
};
const _hoisted_19 = {
  class: "text-line"
};
const _hoisted_20 = {
  class: "text-line"
};
const _hoisted_21 = {
  class: "text-line"
};
const _hoisted_22 = {
  class: "text-line pt-6"
};
const _hoisted_23 = {
  class: "text-line"
};
const _hoisted_24 = {
  class: "running-job-list pt-3 pb-3"
};
const _hoisted_25 = {
  key: 0
};
const _hoisted_26 = {
  class: "progress"
};
const _hoisted_27 = {
  key: 1,
  class: "task-in-queue"
};
const _hoisted_28 = {
  class: "finish-job-list"
};
const _hoisted_29 = {
  key: 0,
  class: "failed"
};
const _hoisted_30 = {
  class: "opt"
};
const _hoisted_31 = {
  key: 1,
  class: "job-item"
};
const _hoisted_32 = {
  key: 0,
  class: "opt"
};
const _hoisted_33 = ["onClick"];
const _hoisted_34 = ["onClick"];
const _hoisted_35 = ["onClick"];
const _hoisted_36 = ["onClick"];
const _hoisted_37 = ["onClick"];
const _hoisted_38 = ["onClick"];
const _hoisted_39 = ["onClick"];
const _hoisted_40 = ["onClick"];
const _hoisted_41 = {
  class: "remove"
};
const _hoisted_42 = ["data-clipboard-text"];
import { nextTick, onMounted, onUnmounted, ref } from "vue";
import { showConfirmDialog, showFailToast, showImagePreview, showNotify, showSuccessToast, showToast, showDialog } from "vant";
import { httpGet, httpPost } from "@/utils/http";
import Compressor from "compressorjs";
import { getSessionId } from "@/store/session";
import { checkSession, getClientId, getSystemInfo } from "@/store/cache";
import { useRouter } from "vue-router";
import { Delete } from "@element-plus/icons-vue";
import { showLoginDialog } from "@/utils/libs";
import Clipboard from "clipboard";
import { useSharedStore } from "@/store/sharedata";
export default {
  __name: 'ImageMj',
  setup(__props) {
    const activeColspan = ref([""]);
    const rates = [{
      css: "square",
      value: "1:1",
      text: "1:1",
      img: "/images/mj/rate_1_1.png"
    }, {
      css: "size2-3",
      value: "2:3",
      text: "2:3",
      img: "/images/mj/rate_3_4.png"
    }, {
      css: "size3-4",
      value: "3:4",
      text: "3:4",
      img: "/images/mj/rate_3_4.png"
    }, {
      css: "size4-3",
      value: "4:3",
      text: "4:3",
      img: "/images/mj/rate_4_3.png"
    }, {
      css: "size16-9",
      value: "16:9",
      text: "16:9",
      img: "/images/mj/rate_16_9.png"
    }, {
      css: "size9-16",
      value: "9:16",
      text: "9:16",
      img: "/images/mj/rate_9_16.png"
    }];
    const models = [{
      text: "MJ-6.0",
      value: " --v 6",
      img: "/images/mj/mj-v6.png"
    }, {
      text: "MJ-5.2",
      value: " --v 5.2",
      img: "/images/mj/mj-v5.2.png"
    }, {
      text: "Niji5",
      value: " --niji 5",
      img: "/images/mj/mj-niji.png"
    }, {
      text: "Niji5 可爱",
      value: " --niji 5 --style cute",
      img: "/images/mj/nj1.jpg"
    }, {
      text: "Niji5 风景",
      value: " --niji 5 --style scenic",
      img: "/images/mj/nj2.jpg"
    }, {
      text: "Niji6",
      value: " --niji 6",
      img: "/images/mj/nj3.jpg"
    }];
    const imgList = ref([]);
    const params = ref({
      client_id: getClientId(),
      task_type: "image",
      rate: rates[0].value,
      model: models[0].value,
      chaos: 0,
      stylize: 0,
      seed: 0,
      img_arr: [],
      raw: false,
      iw: 0,
      prompt: "",
      neg_prompt: "",
      tile: false,
      quality: 0,
      cref: "",
      sref: "",
      cw: 0
    });
    const userId = ref(0);
    const router = useRouter();
    const runningJobs = ref([]);
    const finishedJobs = ref([]);
    const power = ref(0);
    const activeName = ref("txt2img");
    const isLogin = ref(false);
    const prompt = ref("");
    const store = useSharedStore();
    const clipboard = ref(null);
    onMounted(() => {
      clipboard.value = new Clipboard(".copy-prompt");
      clipboard.value.on("success", () => {
        showNotify({
          type: "success",
          message: "复制成功",
          duration: 1000
        });
      });
      clipboard.value.on("error", () => {
        showNotify({
          type: "danger",
          message: "复制失败",
          duration: 2000
        });
      });
      checkSession().then(user => {
        power.value = user["power"];
        userId.value = user.id;
        isLogin.value = true;
        fetchRunningJobs();
        fetchFinishJobs(1);
      }).catch(() => {
        // router.push('/login')
      });
      store.addMessageHandler("mj", data => {
        if (data.channel !== "mj" || data.clientId !== getClientId()) {
          return;
        }
        if (data.body === "FINISH" || data.body === "FAIL") {
          page.value = 1;
          fetchFinishJobs(1);
        }
        fetchRunningJobs();
      });
    });
    onUnmounted(() => {
      clipboard.value.destroy();
      store.removeMessageHandler("mj");
    });
    const mjPower = ref(1);
    const mjActionPower = ref(1);
    getSystemInfo().then(res => {
      mjPower.value = res.data["mj_power"];
      mjActionPower.value = res.data["mj_action_power"];
    }).catch(e => {
      showNotify({
        type: "danger",
        message: "获取系统配置失败：" + e.message
      });
    });

    // 获取运行中的任务
    const fetchRunningJobs = userId => {
      httpGet(`/api/mj/jobs?finish=0&user_id=${userId}`).then(res => {
        const jobs = res.data.items;
        const _jobs = [];
        for (let i = 0; i < jobs.length; i++) {
          if (jobs[i].progress === -1) {
            showNotify({
              message: `任务执行失败：${jobs[i]["err_msg"]}`,
              type: "danger"
            });
            if (jobs[i].type === "image") {
              power.value += mjPower.value;
            } else {
              power.value += mjActionPower.value;
            }
            continue;
          }
          _jobs.push(jobs[i]);
        }
        runningJobs.value = _jobs;
      }).catch(e => {
        showNotify({
          type: "danger",
          message: "获取任务失败：" + e.message
        });
      });
    };
    const loading = ref(false);
    const finished = ref(false);
    const error = ref(false);
    const page = ref(0);
    const pageSize = ref(10);
    const fetchFinishJobs = page => {
      loading.value = true;
      // 获取已完成的任务
      httpGet(`/api/mj/jobs?finish=1&page=${page}&page_size=${pageSize.value}`).then(res => {
        const jobs = res.data.items;
        for (let i = 0; i < jobs.length; i++) {
          if (jobs[i].type === "upscale" || jobs[i].type === "swapFace") {
            jobs[i]["thumb_url"] = jobs[i]["img_url"] + "?imageView2/1/w/480/h/600/q/75";
          } else {
            jobs[i]["thumb_url"] = jobs[i]["img_url"] + "?imageView2/1/w/480/h/480/q/75";
          }
          if (jobs[i].type !== "upscale" && jobs[i].progress === 100) {
            jobs[i]["can_opt"] = true;
          }
        }
        if (jobs.length < pageSize.value) {
          finished.value = true;
        }
        if (page === 1) {
          finishedJobs.value = jobs;
        } else {
          finishedJobs.value = finishedJobs.value.concat(jobs);
        }
        nextTick(() => loading.value = false);
      }).catch(e => {
        loading.value = false;
        error.value = true;
        showFailToast("获取任务失败：" + e.message);
      });
    };
    const onLoad = () => {
      page.value += 1;
      fetchFinishJobs(page.value);
    };

    // 切换图片比例
    const changeRate = item => {
      params.value.rate = item.value;
    };
    // 切换模型
    const changeModel = item => {
      params.value.model = item.value;
    };
    const imgKey = ref("");
    const beforeUpload = key => {
      imgKey.value = key;
    };

    // 图片上传
    const uploadImg = file => {
      file.status = "uploading";
      // 压缩图片并上传
      new Compressor(file.file, {
        quality: 0.6,
        success(result) {
          const formData = new FormData();
          formData.append("file", result, result.name);
          // 执行上传操作
          httpPost("/upload", formData).then(res => {
            file.url = res.data.url;
            if (imgKey.value !== "") {
              // 单张图片上传
              params.value[imgKey.value] = res.data.url;
              imgKey.value = "";
            }
            file.status = "done";
          }).catch(e => {
            file.status = "failed";
            file.message = "上传失败";
            showFailToast("图片上传失败：" + e.message);
          });
        },
        error(err) {
          console.log(err.message);
        }
      });
    };
    const send = (url, index, item) => {
      httpPost(url, {
        client_id: getClientId(),
        index: index,
        channel_id: item.channel_id,
        message_id: item.message_id,
        message_hash: item.hash,
        session_id: getSessionId(),
        prompt: item.prompt
      }).then(() => {
        showSuccessToast("任务推送成功，请耐心等待任务执行...");
        power.value -= mjActionPower.value;
        fetchRunningJobs();
      }).catch(e => {
        showFailToast("任务推送失败：" + e.message);
      });
    };

    // 图片放大任务
    const upscale = (index, item) => {
      send("/mj/upscale", index, item);
    };

    // 图片变换任务
    const variation = (index, item) => {
      send("/mj/variation", index, item);
    };
    const generate = () => {
      if (!isLogin.value) {
        return showLoginDialog(router);
      }
      if (params.value.prompt === "" && params.value.task_type === "image") {
        return showFailToast("请输入绘画提示词！");
      }
      if (params.value.model.indexOf("niji") !== -1 && params.value.raw) {
        return showFailToast("动漫模型不允许启用原始模式");
      }
      params.value.session_id = getSessionId();
      params.value.img_arr = imgList.value.map(img => img.url);
      httpPost("/mj/image", params.value).then(() => {
        showToast("绘画任务推送成功，请耐心等待任务执行");
        power.value -= mjPower.value;
        fetchRunningJobs();
      }).catch(e => {
        showFailToast("任务推送失败：" + e.message);
      });
    };
    const removeImage = item => {
      showConfirmDialog({
        title: "删除提示",
        message: "此操作将会删除任务和图片，继续操作码?"
      }).then(() => {
        httpGet("/mj/remove", {
          id: item.id,
          user_id: item.user_id
        }).then(() => {
          showSuccessToast("任务删除成功");
          fetchFinishJobs(1);
        }).catch(e => {
          showFailToast("任务删除失败：" + e.message);
        });
      }).catch(() => {
        showToast("您取消了操作");
      });
    };
    // 发布图片到作品墙
    const publishImage = (item, action) => {
      let text = "图片发布";
      if (action === false) {
        text = "取消发布";
      }
      httpGet("/mj/publish", {
        id: item.id,
        action: action,
        user_id: item.user_id
      }).then(() => {
        showSuccessToast(text + "成功");
        item.publish = action;
      }).catch(e => {
        showFailToast(text + "失败：" + e.message);
      });
    };
    const showPrompt = item => {
      prompt.value = item.prompt;
      showConfirmDialog({
        title: "绘画提示词",
        message: item.prompt,
        confirmButtonText: "复制",
        cancelButtonText: "关闭"
      }).then(() => {
        document.querySelector("#copy-btn").click();
      }).catch(() => {});
    };
    const showErrMsg = item => {
      showDialog({
        title: "错误详情",
        message: item["err_msg"]
      }).then(() => {
        // on close
      });
    };
    const imageView = item => {
      showImagePreview([item["img_url"]]);
    };

    // 切换菜单
    const tabChange = tab => {
      if (tab === "txt2img" || tab === "img2img") {
        params.value.task_type = "image";
      } else {
        params.value.task_type = tab;
      }
    };
    return (_ctx, _cache) => {
      const _component_van_image = _resolveComponent("van-image");
      const _component_van_col = _resolveComponent("van-col");
      const _component_van_row = _resolveComponent("van-row");
      const _component_van_text_ellipsis = _resolveComponent("van-text-ellipsis");
      const _component_van_slider = _resolveComponent("van-slider");
      const _component_van_field = _resolveComponent("van-field");
      const _component_van_switch = _resolveComponent("van-switch");
      const _component_van_tab = _resolveComponent("van-tab");
      const _component_van_uploader = _resolveComponent("van-uploader");
      const _component_van_button = _resolveComponent("van-button");
      const _component_van_cell_group = _resolveComponent("van-cell-group");
      const _component_van_tabs = _resolveComponent("van-tabs");
      const _component_van_collapse_item = _resolveComponent("van-collapse-item");
      const _component_van_collapse = _resolveComponent("van-collapse");
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_van_form = _resolveComponent("van-form");
      const _component_van_empty = _resolveComponent("van-empty");
      const _component_van_circle = _resolveComponent("van-circle");
      const _component_van_grid_item = _resolveComponent("van-grid-item");
      const _component_van_grid = _resolveComponent("van-grid");
      const _component_van_loading = _resolveComponent("van-loading");
      const _component_el_button = _resolveComponent("el-button");
      const _component_van_list = _resolveComponent("van-list");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_form, {
        onSubmit: generate
      }, {
        default: _withCtx(() => [_cache[27] || (_cache[27] = _createElementVNode("div", {
          class: "text-line"
        }, "图片比例", -1)), _createElementVNode("div", _hoisted_2, [_createVNode(_component_van_row, {
          gutter: 10
        }, {
          default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(rates, item => {
            return _createVNode(_component_van_col, {
              span: 4,
              key: item.value
            }, {
              default: _withCtx(() => [_createElementVNode("div", {
                class: _normalizeClass(item.value === params.value.rate ? 'rate active' : 'rate'),
                onClick: $event => changeRate(item)
              }, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_van_image, {
                src: item.img,
                fit: "cover"
              }, null, 8, ["src"])]), _createElementVNode("div", _hoisted_5, _toDisplayString(item.text), 1)], 10, _hoisted_3)]),
              _: 2
            }, 1024);
          }), 64))]),
          _: 1
        })]), _cache[28] || (_cache[28] = _createElementVNode("div", {
          class: "text-line"
        }, "模型选择", -1)), _createElementVNode("div", _hoisted_6, [_createVNode(_component_van_row, {
          gutter: 10
        }, {
          default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(models, item => {
            return _createVNode(_component_van_col, {
              span: 8,
              key: item.value
            }, {
              default: _withCtx(() => [_createElementVNode("div", {
                class: _normalizeClass(item.value === params.value.model ? 'model active' : 'model'),
                onClick: $event => changeModel(item)
              }, [_createElementVNode("div", _hoisted_8, [_createVNode(_component_van_image, {
                src: item.img,
                fit: "cover"
              }, null, 8, ["src"])]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_van_text_ellipsis, {
                content: item.text
              }, null, 8, ["content"])])], 10, _hoisted_7)]),
              _: 2
            }, 1024);
          }), 64))]),
          _: 1
        })]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_van_field, {
          label: "创意度"
        }, {
          input: _withCtx(() => [_createVNode(_component_van_slider, {
            modelValue: params.value.chaos,
            "onUpdate:modelValue": [_cache[0] || (_cache[0] = $event => params.value.chaos = $event), _cache[1] || (_cache[1] = $event => _unref(showToast)('当前值：' + params.value.chaos))],
            modelModifiers: {
              number: true
            },
            max: 100,
            step: 1
          }, null, 8, ["modelValue"])]),
          _: 1
        })]), _createElementVNode("div", _hoisted_11, [_createVNode(_component_van_field, {
          label: "风格化"
        }, {
          input: _withCtx(() => [_createVNode(_component_van_slider, {
            modelValue: params.value.stylize,
            "onUpdate:modelValue": [_cache[2] || (_cache[2] = $event => params.value.stylize = $event), _cache[3] || (_cache[3] = $event => _unref(showToast)('当前值：' + params.value.stylize))],
            modelModifiers: {
              number: true
            },
            max: 1000,
            step: 1
          }, null, 8, ["modelValue"])]),
          _: 1
        })]), _createElementVNode("div", _hoisted_12, [_createVNode(_component_van_field, {
          label: "原始模式"
        }, {
          input: _withCtx(() => [_createVNode(_component_van_switch, {
            modelValue: params.value.raw,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => params.value.raw = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        })]), _createElementVNode("div", _hoisted_13, [_createVNode(_component_van_tabs, {
          active: activeName.value,
          "onUpdate:active": _cache[18] || (_cache[18] = $event => activeName.value = $event),
          onChange: tabChange,
          animated: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_van_tab, {
            title: "文生图",
            name: "txt2img"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_14, [_createVNode(_component_van_field, {
              modelValue: params.value.prompt,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => params.value.prompt = $event),
              rows: "3",
              autosize: "",
              type: "textarea",
              placeholder: "请在此输入绘画提示词，系统会自动翻译中文提示词，高手请直接输入英文提示词"
            }, null, 8, ["modelValue"])])]),
            _: 1
          }), _createVNode(_component_van_tab, {
            title: "图生图",
            name: "img2img"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_15, [_createVNode(_component_van_field, {
              modelValue: params.value.prompt,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => params.value.prompt = $event),
              rows: "3",
              autosize: "",
              type: "textarea",
              placeholder: "请在此输入绘画提示词，系统会自动翻译中文提示词，高手请直接输入英文提示词"
            }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_16, [_createVNode(_component_van_uploader, {
              modelValue: imgList.value,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => imgList.value = $event),
              "after-read": uploadImg
            }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_17, [_createVNode(_component_van_field, {
              label: "垫图权重"
            }, {
              input: _withCtx(() => [_createVNode(_component_van_slider, {
                modelValue: params.value.iw,
                "onUpdate:modelValue": [_cache[8] || (_cache[8] = $event => params.value.iw = $event), _cache[9] || (_cache[9] = $event => _unref(showToast)('当前值：' + params.value.iw))],
                modelModifiers: {
                  number: true
                },
                max: 1,
                step: 0.01
              }, null, 8, ["modelValue"])]),
              _: 1
            })]), _cache[23] || (_cache[23] = _createElementVNode("div", {
              class: "tip-text"
            }, "提示：只有于 niji6 和 v6 模型支持一致性功能，如果选择其他模型此功能将会生成失败。", -1)), _createVNode(_component_van_cell_group, null, {
              default: _withCtx(() => [_createVNode(_component_van_field, {
                modelValue: params.value.cref,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => params.value.cref = $event),
                center: "",
                clearable: "",
                label: "角色一致性",
                placeholder: "请输入图片URL或者上传图片"
              }, {
                button: _withCtx(() => [_createVNode(_component_van_uploader, {
                  onClick: _cache[10] || (_cache[10] = $event => beforeUpload('cref')),
                  "after-read": uploadImg
                }, {
                  default: _withCtx(() => [_createVNode(_component_van_button, {
                    size: "mini",
                    type: "primary",
                    icon: "plus"
                  })]),
                  _: 1
                })]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_van_cell_group, null, {
              default: _withCtx(() => [_createVNode(_component_van_field, {
                modelValue: params.value.sref,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => params.value.sref = $event),
                center: "",
                clearable: "",
                label: "风格一致性",
                placeholder: "请输入图片URL或者上传图片"
              }, {
                button: _withCtx(() => [_createVNode(_component_van_uploader, {
                  onClick: _cache[12] || (_cache[12] = $event => beforeUpload('sref')),
                  "after-read": uploadImg
                }, {
                  default: _withCtx(() => [_createVNode(_component_van_button, {
                    size: "mini",
                    type: "primary",
                    icon: "plus"
                  })]),
                  _: 1
                })]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            }), _createElementVNode("div", _hoisted_18, [_createVNode(_component_van_field, {
              label: "一致性权重"
            }, {
              input: _withCtx(() => [_createVNode(_component_van_slider, {
                modelValue: params.value.cw,
                "onUpdate:modelValue": [_cache[14] || (_cache[14] = $event => params.value.cw = $event), _cache[15] || (_cache[15] = $event => _unref(showToast)('当前值：' + params.value.cw))],
                modelModifiers: {
                  number: true
                },
                max: 100,
                step: 1
              }, null, 8, ["modelValue"])]),
              _: 1
            })])]),
            _: 1
          }), _createVNode(_component_van_tab, {
            title: "融图",
            name: "blend"
          }, {
            default: _withCtx(() => [_cache[24] || (_cache[24] = _createElementVNode("div", {
              class: "tip-text"
            }, "请上传两张以上的图片，最多不超过五张，超过五张图片请使用图生图功能。", -1)), _createElementVNode("div", _hoisted_19, [_createVNode(_component_van_uploader, {
              modelValue: imgList.value,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => imgList.value = $event),
              "after-read": uploadImg
            }, null, 8, ["modelValue"])])]),
            _: 1
          }), _createVNode(_component_van_tab, {
            title: "换脸",
            name: "swapFace"
          }, {
            default: _withCtx(() => [_cache[25] || (_cache[25] = _createElementVNode("div", {
              class: "tip-text"
            }, "请上传两张有脸部的图片，用左边图片的脸替换右边图片的脸。", -1)), _createElementVNode("div", _hoisted_20, [_createVNode(_component_van_uploader, {
              modelValue: imgList.value,
              "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => imgList.value = $event),
              "after-read": uploadImg
            }, null, 8, ["modelValue"])])]),
            _: 1
          })]),
          _: 1
        }, 8, ["active"])]), _createElementVNode("div", _hoisted_21, [_createVNode(_component_van_collapse, {
          modelValue: activeColspan.value,
          "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => activeColspan.value = $event)
        }, {
          default: _withCtx(() => [_createVNode(_component_van_collapse_item, {
            title: "反向提示词",
            name: "neg_prompt"
          }, {
            default: _withCtx(() => [_createVNode(_component_van_field, {
              modelValue: params.value.neg_prompt,
              "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => params.value.neg_prompt = $event),
              rows: "3",
              autosize: "",
              type: "textarea",
              placeholder: "不想出现在图片上的元素(例如：树，建筑)"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_22, [_createVNode(_component_el_tag, null, {
          default: _withCtx(() => [_createTextVNode("绘图消耗" + _toDisplayString(mjPower.value) + "算力，U/V 操作消耗" + _toDisplayString(mjActionPower.value) + "算力，当前算力：" + _toDisplayString(power.value), 1)]),
          _: 1
        })]), _createElementVNode("div", _hoisted_23, [_createVNode(_component_van_button, {
          round: "",
          block: "",
          type: "primary",
          "native-type": "submit"
        }, {
          default: _withCtx(() => _cache[26] || (_cache[26] = [_createTextVNode(" 立即生成 ")])),
          _: 1
        })])]),
        _: 1
      }), _cache[37] || (_cache[37] = _createElementVNode("h3", null, "任务列表", -1)), _createElementVNode("div", _hoisted_24, [runningJobs.value.length === 0 ? (_openBlock(), _createBlock(_component_van_empty, {
        key: 0,
        image: "https://fastly.jsdelivr.net/npm/@vant/assets/custom-empty-image.png",
        "image-size": "80",
        description: "暂无记录"
      })) : (_openBlock(), _createBlock(_component_van_grid, {
        key: 1,
        gutter: 10,
        "column-num": 3
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(runningJobs.value, item => {
          return _openBlock(), _createBlock(_component_van_grid_item, {
            key: item.id
          }, {
            default: _withCtx(() => [item.progress > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_25, [_createVNode(_component_van_image, {
              src: "/images/img-holder.png"
            }), _createElementVNode("div", _hoisted_26, [_createVNode(_component_van_circle, {
              "current-rate": item.progress,
              "onUpdate:currentRate": $event => item.progress = $event,
              rate: item.progress,
              speed: 100,
              text: item.progress + '%',
              "stroke-width": 60,
              size: "90px"
            }, null, 8, ["current-rate", "onUpdate:currentRate", "rate", "text"])])])) : (_openBlock(), _createElementBlock("div", _hoisted_27, _cache[29] || (_cache[29] = [_createElementVNode("span", {
              class: "icon"
            }, [_createElementVNode("i", {
              class: "iconfont icon-quick-start"
            })], -1), _createElementVNode("span", {
              class: "text"
            }, "排队中", -1)])))]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 1
      }))]), _cache[38] || (_cache[38] = _createElementVNode("h3", null, "创作记录", -1)), _createElementVNode("div", _hoisted_28, [finishedJobs.value.length === 0 ? (_openBlock(), _createBlock(_component_van_empty, {
        key: 0,
        image: "https://fastly.jsdelivr.net/npm/@vant/assets/custom-empty-image.png",
        "image-size": "80",
        description: "暂无记录"
      })) : (_openBlock(), _createBlock(_component_van_list, {
        key: 1,
        error: error.value,
        "onUpdate:error": _cache[21] || (_cache[21] = $event => error.value = $event),
        loading: loading.value,
        "onUpdate:loading": _cache[22] || (_cache[22] = $event => loading.value = $event),
        finished: finished.value,
        "error-text": "请求失败，点击重新加载",
        "finished-text": "没有更多了",
        onLoad: onLoad
      }, {
        default: _withCtx(() => [_createVNode(_component_van_grid, {
          gutter: 10,
          "column-num": 2
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(finishedJobs.value, item => {
            return _openBlock(), _createBlock(_component_van_grid_item, {
              key: item.id
            }, {
              default: _withCtx(() => [item.progress === 101 ? (_openBlock(), _createElementBlock("div", _hoisted_29, [_cache[32] || (_cache[32] = _createElementVNode("div", {
                class: "title"
              }, "任务失败", -1)), _createElementVNode("div", _hoisted_30, [_createVNode(_component_van_button, {
                size: "small",
                onClick: $event => showErrMsg(item)
              }, {
                default: _withCtx(() => _cache[30] || (_cache[30] = [_createTextVNode("详情")])),
                _: 2
              }, 1032, ["onClick"]), _createVNode(_component_van_button, {
                type: "danger",
                onClick: $event => removeImage(item),
                size: "small"
              }, {
                default: _withCtx(() => _cache[31] || (_cache[31] = [_createTextVNode("删除")])),
                _: 2
              }, 1032, ["onClick"])])])) : (_openBlock(), _createElementBlock("div", _hoisted_31, [_createVNode(_component_van_image, {
                src: item['thumb_url'],
                class: _normalizeClass(item['can_opt'] ? '' : 'upscale'),
                "lazy-load": "",
                onClick: $event => imageView(item),
                fit: "cover"
              }, {
                loading: _withCtx(() => [_createVNode(_component_van_loading, {
                  type: "spinner",
                  size: "20"
                })]),
                error: _withCtx(() => [_cache[33] || (_cache[33] = _createElementVNode("span", {
                  style: {
                    "margin-bottom": "20px"
                  }
                }, "正在下载图片", -1)), _createVNode(_component_van_loading, {
                  type: "circular",
                  color: "#1989fa",
                  size: "40"
                })]),
                _: 2
              }, 1032, ["src", "class", "onClick"]), item['can_opt'] ? (_openBlock(), _createElementBlock("div", _hoisted_32, [_createVNode(_component_van_grid, {
                gutter: 3,
                "column-num": 4
              }, {
                default: _withCtx(() => [_createVNode(_component_van_grid_item, null, {
                  default: _withCtx(() => [_createElementVNode("a", {
                    onClick: $event => upscale(1, item),
                    class: "opt-btn"
                  }, "U1", 8, _hoisted_33)]),
                  _: 2
                }, 1024), _createVNode(_component_van_grid_item, null, {
                  default: _withCtx(() => [_createElementVNode("a", {
                    onClick: $event => upscale(2, item),
                    class: "opt-btn"
                  }, "U2", 8, _hoisted_34)]),
                  _: 2
                }, 1024), _createVNode(_component_van_grid_item, null, {
                  default: _withCtx(() => [_createElementVNode("a", {
                    onClick: $event => upscale(3, item),
                    class: "opt-btn"
                  }, "U3", 8, _hoisted_35)]),
                  _: 2
                }, 1024), _createVNode(_component_van_grid_item, null, {
                  default: _withCtx(() => [_createElementVNode("a", {
                    onClick: $event => upscale(4, item),
                    class: "opt-btn"
                  }, "U4", 8, _hoisted_36)]),
                  _: 2
                }, 1024), _createVNode(_component_van_grid_item, null, {
                  default: _withCtx(() => [_createElementVNode("a", {
                    onClick: $event => variation(1, item),
                    class: "opt-btn"
                  }, "V1", 8, _hoisted_37)]),
                  _: 2
                }, 1024), _createVNode(_component_van_grid_item, null, {
                  default: _withCtx(() => [_createElementVNode("a", {
                    onClick: $event => variation(2, item),
                    class: "opt-btn"
                  }, "V2", 8, _hoisted_38)]),
                  _: 2
                }, 1024), _createVNode(_component_van_grid_item, null, {
                  default: _withCtx(() => [_createElementVNode("a", {
                    onClick: $event => variation(3, item),
                    class: "opt-btn"
                  }, "V3", 8, _hoisted_39)]),
                  _: 2
                }, 1024), _createVNode(_component_van_grid_item, null, {
                  default: _withCtx(() => [_createElementVNode("a", {
                    onClick: $event => variation(4, item),
                    class: "opt-btn"
                  }, "V4", 8, _hoisted_40)]),
                  _: 2
                }, 1024)]),
                _: 2
              }, 1024)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_41, [_createVNode(_component_el_button, {
                type: "danger",
                icon: _unref(Delete),
                onClick: $event => removeImage(item),
                circle: ""
              }, null, 8, ["icon", "onClick"]), item.publish ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "warning",
                onClick: $event => publishImage(item, false),
                circle: ""
              }, {
                default: _withCtx(() => _cache[34] || (_cache[34] = [_createElementVNode("i", {
                  class: "iconfont icon-cancel-share"
                }, null, -1)])),
                _: 2
              }, 1032, ["onClick"])) : (_openBlock(), _createBlock(_component_el_button, {
                key: 1,
                type: "success",
                onClick: $event => publishImage(item, true),
                circle: ""
              }, {
                default: _withCtx(() => _cache[35] || (_cache[35] = [_createElementVNode("i", {
                  class: "iconfont icon-share-bold"
                }, null, -1)])),
                _: 2
              }, 1032, ["onClick"])), _createVNode(_component_el_button, {
                type: "primary",
                onClick: $event => showPrompt(item),
                circle: ""
              }, {
                default: _withCtx(() => _cache[36] || (_cache[36] = [_createElementVNode("i", {
                  class: "iconfont icon-prompt"
                }, null, -1)])),
                _: 2
              }, 1032, ["onClick"])])]))]),
              _: 2
            }, 1024);
          }), 128))]),
          _: 1
        })]),
        _: 1
      }, 8, ["error", "loading", "finished"]))]), _createElementVNode("button", {
        style: {
          "display": "none"
        },
        class: "copy-prompt",
        "data-clipboard-text": prompt.value,
        id: "copy-btn"
      }, "复制", 8, _hoisted_42)]);
    };
  }
};